export const ADD_SUBCONTRACTOR_ASYNC = 'ADD_SUBCONTRACTOR_ASYNC';
export const ADD_SUBCONTRACTOR_SUCCESS = 'ADD_SUBCONTRACTOR_SUCCESS';

export const SEARCH_SUBCONTRACTOR_ASYNC = 'SEARCH_SUBCONTRACTOR_ASYNC';
export const SEARCH_SUBCONTRACTOR_SUCCESS = 'SEARCH_SUBCONTRACTOR_SUCCESS';

export const ADD_EDIT_SUBCONTRACTOR_ERROR = 'ADD_EDIT_SUBCONTRACTOR_ERROR';

export const GET_SUBCONTRACTOR_BY_EMAIL_ASYNC =
  'GET_SUBCONTRACTOR_BY_EMAIL_ASYNC';
export const GET_SUBCONTRACTOR_BY_EMAIL_SUCCESS =
  'GET_SUBCONTRACTOR_BY_EMAIL_SUCCESS';

export const GET_SUBCONTRACTOR_BY_NAME_ASYNC =
  'GET_SUBCONTRACTOR_BY_NAME_ASYNC';
export const GET_SUBCONTRACTOR_BY_NAME_SUCCESS =
  'GET_SUBCONTRACTOR_BY_NAME_SUCCESS';

export const INVITE_SUBCONTRACTOR_ADMIN_ASYNC =
  'INVITE_SUBCONTRACTOR_ADMIN_ASYNC';
export const INVITE_SUBCONTRACTOR_ADMIN_SUCCESS =
  'INVITE_SUBCONTRACTOR_ADMIN_SUCCESS';

export const CLONE_SUBCONTRACTOR_ASYNC = 'CLONE_SUBCONTRACTOR_ASYNC';

export const RESET_SUBCONTRACTOR = 'RESET_SUBCONTRACTOR';

export const ASSIGN_SUB_OF_PROJECT_ASYNC = 'ASSIGN_SUB_OF_PROJECT_ASYNC';
export const ASSIGN_SUB_OF_PROJECT_SUCCESS = 'ASSIGN_SUB_OF_PROJECT_SUCCESS';

export const SEARCH_SUB_OF_PROJECT_ASYNC = 'SEARCH_SUB_OF_PROJECT_ASYNC';
export const SEARCH_SUB_OF_PROJECT_SUCCESS = 'SEARCH_SUB_OF_PROJECT_SUCCESS';

export const SEARCH_SUBCONTRACTOR_ASSIGNMENT_TO_PROJECT_ASYNC =
  'SEARCH_SUBCONTRACTOR_ASSIGNMENT_TO_PROJECT_ASYNC';
export const SEARCH_SUBCONTRACTOR_ASSIGNMENT_TO_PROJECT_SUCCESS =
  'SEARCH_SUBCONTRACTOR_ASSIGNMENT_TO_PROJECT_SUCCESS';

export const RESET_SUB_OF_PROJECT = 'RESET_SUB_OF_PROJECT';
export const RESET_INVITE_SUBCONTRACTOR_ADMIN =
  'RESET_INVITE_SUBCONTRACTOR_ADMIN';

export const SELECT_LIST_SUBCONTRACTOR_ASYNC =
  'SELECT_LIST_SUBCONTRACTOR_ASYNC';
export const SELECT_LIST_SUBCONTRACTOR_SUCCESS =
  'SELECT_LIST_SUBCONTRACTOR_SUCCESS';

export const SEARCH_ALL_SUBCONTRACTOR_SELECT_LIST =
  'SEARCH_ALL_SUBCONTRACTOR_SELECT_LIST';

export const GET_SUBCONTRACTOR_BY_ID_ASYNC = 'GET_SUBCONTRACTOR_BY_ID_ASYNC';
export const GET_SUBCONTRACTOR_BY_ID_SUCCESS =
  'GET_SUBCONTRACTOR_BY_ID_SUCCESS';

export const RESET_SUBCONTRACTOR_ASSIGNMENT = 'RESET_SUBCONTRACTOR_ASSIGNMENT';

export const RESEND_SUBCONTRACTOR_INVITE_ASYNC =
  'RESEND_SUBCONTRACTOR_INVITE_ASYNC';
export const ASSIGN_TRADE_TO_SUBCONTRACTOR_ASYNC =
  'ASSIGN_TRADE_TO_SUBCONTRACTOR_ASYNC';

export const EDIT_SUBCONTRACTOR_ASYNC = 'EDIT_SUBCONTRACTOR_ASYNC';

export const DELETE_INACTIVE_SUPER_ADMIN_ASYNC =
  'DELETE_INACTIVE_SUPER_ADMIN_ASYNC';

export const GET_SUBCONTRACTOR_SUGGESTION_ASYNC =
  'GET_SUBCONTRACTOR_SUGGESTION_ASYNC';
export const GET_SUBCONTRACTOR_SUGGESTION_SUCCESS =
  'GET_SUBCONTRACTOR_SUGGESTION_SUCCESS';

export const REMOVE_SUPER_ADMIN_FROM_SUBCONTRACTOR_ASYNC =
  'REMOVE_SUPER_ADMIN_FROM_SUBCONTRACTOR_ASYNC';

//Action for SUB ASSIGNMENT REMOVE
export const REMOVE_SUBCONTRACTOR_ASSIGNMENT_ASYNC = 'REMOVE_SUBCONTRACTOR_ASSIGNMENT_ASYNC';
// add contactpoint for subcontractor
export const ADD_CONTACT_POINT_SUBCONTRACTOR_ASYNC = 'ADD_CONTACT_POINT_SUBCONTRACTOR_ASYNC';

//remove contactpoint for subcontractor information
export const REMOVE_CONTACT_POINT_SUBCONTRACTOR_ASYNC = 'REMOVE_CONTACT_POINT_SUBCONTRACTOR_ASYNC';

export const SUBCONTRACTOR_ASSIGNMENT_ERROR = 'SUBCONTRACTOR_ASSIGNMENT_ERROR';



// WEBPACK FOOTER //
// ./src/Subcontractors/constants.js